export default "__VITE_ASSET__D8bLh8fU__"